import { defineMessages } from 'react-intl';

const _default_1: {
	logo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	logo: {
		id: 'fabric.editor.ai.commandPalette.promptForm.logo',
		defaultMessage: 'Atlassian Intelligence Logo',
		description:
			'Alt text for the Atlassian Intelligence logo image displayed in the prompt form of the Editor AI command palette.',
	},
});
export default _default_1;
